import { useCallback } from 'react';
import { apiClient } from '@/lib/api/client';
import { useAuthStore } from '@/lib/auth';
import type { SupportedLanguage } from '../config/languages';
import { useDetectedLanguage } from './useDetectedLanguage';
import { useUpdateLocale } from './useUpdateLocale';

/**
 * 開発者ショートカット用の日英トグル動作を返す。
 * キー購読は registry 側（features/shortcuts の useShortcut('lang.switch')）が担い、
 * このフックは「現在言語の反転」という動作だけを提供する。
 */
export function useToggleLanguage(): () => void {
  const authStore = useAuthStore();
  const {
    detectedLanguage
  } = useDetectedLanguage();
  const mutator = useUpdateLocale({
    apiClient: {
      PATCH: (_url: string, options: {
        body: {
          locale: SupportedLanguage;
        };
      }) => apiClient.PATCH('/v2/me/locale' as const, options)
    },
    authStore: {
      isAuthenticated: authStore.isAuthenticated,
      setLocale: authStore.setLocale
    }
  });
  return useCallback(() => {
    mutator.mutate(detectedLanguage === 'en-US' ? 'ja-JP' : 'en-US');
  }, [detectedLanguage, mutator]);
}